// // @ts-nocheck
// import React, { useEffect, useState } from 'react';
// import { Form } from 'react-bootstrap';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { editEmployee, getEmployees } from '@store/HR/Person/employeeSlice';
// import { EditPersonSchema } from '../../../../ValidationForm/validationSchema';
// import { useDispatch } from 'react-redux';
// import ExtraInformationBuilderUpdate from '../../../../ExtraInformation/ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';
// import EditEmployees from './EditEmployees';
// import useEmpDetails from '@hooks/HR/use-employee-details.js';
// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
// import { Card, CardBody } from '@components/card/card.jsx';
// // import SkeletonForm from '@components/Shared/SkeletonLoader/SkeletonForm.js';
// import useAddUpdateExtraInformation from '../../../../ExtraInformation/ExtraInformationBuilder/useAddUpdateExtraInformation.js';
// import { GetDynamicFormColumnListByTableId } from '@store/NTX/FlexValue/Form/FormColumnSlice.js';
// import { useSelector } from 'react-redux';
// import ExtraInformationBuilderAdd from '../../../../ExtraInformation/ExtraInformationBuilder/Add/ExtraInformationBuilderAdd.jsx';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import Loading from '@components/Shared/Loader/Loading';

// const UpdatePerson = () => {
//   const { HasPermission } = usePermissions();

//   const dispatch = useDispatch();
//   const Navigate = useNavigate();
//   const { t, i18n } = useTranslation();
//   const { AddUpdateExtraInformation } = useAddUpdateExtraInformation();
//   const [extraInfoFormData, setExtraInfoFormData] = useState({});
//   const { loading: dataLoading, Employee, error } = useEmpDetails();

//   //__________ جلب حقول المعلومات الإضافية ان وجدت __________
//   const TableId = 'cd5aa419-0e0b-48fe-a66f-f004d97964a2'; // جدول الموظفين id
//   useEffect(() => {
//     if (Employee?.extraInformationId === null) {
//       dispatch(GetDynamicFormColumnListByTableId(TableId));
//     }
//   }, [Employee, dispatch]);
//   const { FormColumnByTableIdList } = useSelector(state => state.FormColumns);
//   //_________________________________________________________

//   const formik = useFormik({
//     initialValues: {
//       id: Employee ? Employee.id : null,
//       ExtraInformationId: Employee ? Employee.extraInformationId : null,
//       employeeNumber: Employee ? Employee.employeeNumber : '',
//       NAME2: Employee ? Employee.name2 : '',
//       NAME: Employee ? Employee.name : '',
//       NATIONAL_IDENTIFIER: Employee ? Employee?.nationalIdentifier : '',
//       START_DATE: Employee ? Employee?.startDate : '',
//       DATE_OF_BIRTH: Employee ? Employee?.dateOfBirth : '',
//       MARITAL_STATUS: Employee ? Employee?.maritalStatus : '',
//       GENDER: Employee ? Employee?.gender : '',
//       NATIONALITY: Employee ? Employee?.nationality : '',
//       TITLE: Employee ? Employee?.title : '',
//       COUNTRY_OF_BIRTH: Employee ? Employee?.countryOfBirth : '',
//       TOWN_OF_BIRTH: Employee ? Employee?.townOfBirth : '',

//       BankId: Employee ? Employee?.bankId : '',
//       // IBan: Employee ? Employee?.iBan : '',
//       IBan: Employee ?? Employee.iBan === 'null' ? '' : Employee.iBan,

//       Religion: Employee ? Employee?.religion : '',
//       RotationPlanId: Employee ? Employee?.rotationPlanId : '',
//       AnnualLeave: Employee ? Employee?.annualLeave : 0,
//       Person_Img: Employee ? Employee?.personImage?.filePath : '',

//       Is_Update_IMG: false,

//       emailAddress: Employee ? Employee?.emailAddress : '',
//       mobile: Employee ? Employee?.mobile : ''
//     },
//     enableReinitialize: true,
//     validationSchema: EditPersonSchema(t),
//     onSubmit: async values => {
//       const formData = new FormData();
//       formData.append('Id', values.id);
//       // formData.append("EmployeeNumber", values.employeeNumber);
//       formData.append('Name2', values.NAME2);
//       formData.append('Name', values.NAME);
//       formData.append('NationalIdentifier', values.NATIONAL_IDENTIFIER);
//       formData.append('StartDate', values.START_DATE);
//       formData.append('DateOfBirth', values.DATE_OF_BIRTH);
//       formData.append('MaritalStatus', values.MARITAL_STATUS);
//       formData.append('Gender', values.GENDER);
//       formData.append('Nationality', values.NATIONALITY);
//       formData.append('Title', values.TITLE);
//       formData.append('CountryOfBirth', values.COUNTRY_OF_BIRTH);
//       formData.append('TownOfBirth', values.TOWN_OF_BIRTH);
//       formData.append('PERSON_IMG', values.Person_Img);
//       formData.append('IBan', values.IBan);
//       formData.append('Religion', values.Religion);
//       formData.append('AnnualLeave', values.AnnualLeave === null ? '' : values.AnnualLeave);
//       formData.append('Religion', values.Religion);
//       formData.append('BankId', values.BankId === null ? '' : values.BankId);

//       formData.append('EmailAddress', values.emailAddress === null ? '' : values.emailAddress);
//       formData.append('Mobile', values.mobile === null ? '' : values.mobile);
//       formData.append('RotationPlanId', values.RotationPlanId === null ? '' : values.RotationPlanId);
//       formData.append('Is_Update_IMG', values.Is_Update_IMG);

//       let respons;
//       if (extraInfoFormData?.values?.length > 0) {
//         respons = await AddUpdateExtraInformation(extraInfoFormData);
//       }
//       if (respons === null) {
//         CustomAlert({ action: 'Error' });
//         return;
//       }
//       formData.append('ExtraInformationId', respons || '');
//       dispatch(editEmployee(formData))
//         .unwrap()
//         .then(res => {
//           Navigate('/HR/Employees', { replace: true });
//           CustomAlert({ action: 'Edit' });
//           dispatch(getEmployees());
//           formik.resetForm();
//         })
//         .catch(error => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });

//   // console.log(formik.errors);

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: 'Home',
//             link: ':moduleHome'
//           },
//           {
//             name: 'Employees',
//             link: '/HR/Employees'
//           },
//           {
//             name: t('EmployeeDetails'),
//             link: null
//           }
//         ]}
//         PageName={t('EmployeeDetails')}
//         subtitle={i18n.language === 'ar' ? Employee.name2 : Employee.name}
//       />

//       <Card>
//         <CardBody>
//           <Loading loading={dataLoading} error={error}>
//             <Form onSubmit={formik.handleSubmit}>
//               <EditEmployees formik={formik} />

//               <div className='rounded-2 p-3 mb-3 border border-theme'>
//                 <div className='d-flex align-items-center mb-3'>
//                   <i className='fa fa-info-circle fa-lg text-theme me-2'></i>
//                   <h5 className='mb-0'>{t('ExtraInformation')}</h5>
//                 </div>
//                 {Employee?.extraInformationId ? (
//                   <ExtraInformationBuilderUpdate
//                     extraInformationId={formik.values.ExtraInformationId}
//                     referenceId={Employee?.id}
//                     setExtraInfoFormData={setExtraInfoFormData}
//                   />
//                 ) : (
//                   <ExtraInformationBuilderAdd
//                     FormColumnList={FormColumnByTableIdList}
//                     setExtraInfoFormData={setExtraInfoFormData}
//                     referenceId={Employee?.id}
//                   />
//                 )}
//               </div>

//               <div className='text-center'>
//                 {HasPermission('EditHrPerson') && (
//                   <button disabled={formik.isSubmitting} type='submit' className='btn me-1 btn-theme mb-1'>
//                     <i className='fa fa-save fa-fw me-1'></i>
//                     {formik.isSubmitting ? '...' : t('Save')}
//                   </button>
//                 )}

//                 <button
//                   type='button'
//                   className=' btn me-1 btn-default mb-1'
//                   onClick={() => Navigate(-1, { replace: true })}
//                 >
//                   <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//                 </button>
//               </div>
//             </Form>
//           </Loading>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default UpdatePerson;

// @ts-nocheck
import React, { useEffect, useState, useCallback } from 'react';
import { Form, Alert } from 'react-bootstrap';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { editEmployee, getEmployees } from '@store/HR/Person/employeeSlice';
import { EditPersonSchema } from '../../../../ValidationForm/validationSchema';
import { useDispatch } from 'react-redux';
import ExtraInformationBuilderUpdate from '../../../../ExtraInformation/ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';
import EditEmployees from './EditEmployees';
import useEmpDetails from '@hooks/HR/use-employee-details.js';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader } from '@components/card/card.jsx';
import useAddUpdateExtraInformation from '../../../../ExtraInformation/ExtraInformationBuilder/useAddUpdateExtraInformation.js';
import { GetDynamicFormColumnListByTableId } from '@store/NTX/FlexValue/Form/FormColumnSlice.js';
import { useSelector } from 'react-redux';
import ExtraInformationBuilderAdd from '../../../../ExtraInformation/ExtraInformationBuilder/Add/ExtraInformationBuilderAdd.jsx';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';

const UpdatePerson = () => {
  const { HasPermission } = usePermissions();
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { AddUpdateExtraInformation } = useAddUpdateExtraInformation();
  const [extraInfoFormData, setExtraInfoFormData] = useState({});
  const { loading: dataLoading, Employee, error } = useEmpDetails();

  // تتبع التغييرات غير المحفوظة
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  //__________ جلب حقول المعلومات الإضافية ان وجدت __________
  const TableId = 'cd5aa419-0e0b-48fe-a66f-f004d97964a2';
  useEffect(() => {
    if (Employee?.extraInformationId === null) {
      dispatch(GetDynamicFormColumnListByTableId(TableId));
    }
  }, [Employee, dispatch]);

  const { FormColumnByTableIdList } = useSelector(state => state.FormColumns);
  //_________________________________________________________

  const handleFormChange = useCallback(() => {
    setHasUnsavedChanges(true);
  }, []);

  const formik = useFormik({
    initialValues: {
      id: Employee ? Employee.id : null,
      ExtraInformationId: Employee ? Employee.extraInformationId : null,
      employeeNumber: Employee ? Employee.employeeNumber : '',
      NAME2: Employee ? Employee.name2 : '',
      NAME: Employee ? Employee.name : '',
      NATIONAL_IDENTIFIER: Employee ? Employee?.nationalIdentifier : '',
      START_DATE: Employee ? Employee?.startDate : '',
      DATE_OF_BIRTH: Employee ? Employee?.dateOfBirth : '',
      MARITAL_STATUS: Employee ? Employee?.maritalStatus : '',
      GENDER: Employee ? Employee?.gender : '',
      NATIONALITY: Employee ? Employee?.nationality : '',
      TITLE: Employee ? Employee?.title : '',
      COUNTRY_OF_BIRTH: Employee ? Employee?.countryOfBirth : '',
      TOWN_OF_BIRTH: Employee ? Employee?.townOfBirth : '',
      BankId: Employee ? Employee?.bankId : '',
      IBan: Employee && Employee.iBan !== 'null' ? Employee.iBan : '',
      Religion: Employee ? Employee?.religion : '',
      RotationPlanId: Employee ? Employee?.rotationPlanId : '',
      AnnualLeave: Employee ? Employee?.annualLeave : 0,
      Person_Img: Employee ? Employee?.personImage?.filePath : '',
      Is_Update_IMG: false,
      emailAddress: Employee ? Employee?.emailAddress : '',
      mobile: Employee ? Employee?.mobile : ''
    },
    enableReinitialize: true,
    validationSchema: EditPersonSchema(t),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const formData = new FormData();
        formData.append('Id', values.id);
        formData.append('Name2', values.NAME2);
        formData.append('Name', values.NAME);
        formData.append('NationalIdentifier', values.NATIONAL_IDENTIFIER);
        formData.append('StartDate', values.START_DATE);
        formData.append('DateOfBirth', values.DATE_OF_BIRTH);
        formData.append('MaritalStatus', values.MARITAL_STATUS);
        formData.append('Gender', values.GENDER);
        formData.append('Nationality', values.NATIONALITY);
        formData.append('Title', values.TITLE);
        formData.append('CountryOfBirth', values.COUNTRY_OF_BIRTH);
        formData.append('TownOfBirth', values.TOWN_OF_BIRTH);
        formData.append('PERSON_IMG', values.Person_Img);
        formData.append('IBan', values.IBan);
        formData.append('Religion', values.Religion);
        formData.append('AnnualLeave', values.AnnualLeave === null ? '' : values.AnnualLeave);
        formData.append('BankId', values.BankId === null ? '' : values.BankId);
        formData.append('EmailAddress', values.emailAddress === null ? '' : values.emailAddress);
        formData.append('Mobile', values.mobile === null ? '' : values.mobile);
        formData.append('RotationPlanId', values.RotationPlanId === null ? '' : values.RotationPlanId);
        formData.append('Is_Update_IMG', values.Is_Update_IMG);

        let extraInfoResponse;
        if (extraInfoFormData?.values?.length > 0) {
          extraInfoResponse = await AddUpdateExtraInformation(extraInfoFormData);
          if (extraInfoResponse === null) {
            CustomAlert({ action: 'Error', msg: t('ExtraInfoSaveError') });
            return;
          }
        }

        formData.append('ExtraInformationId', extraInfoResponse || '');

        const res = await dispatch(editEmployee(formData)).unwrap();
        debugger;
        if (res.succeeded === true) {
          CustomAlert({
            action: 'Edit'
          });
          setTimeout(() => {
            Navigate('/HR/Employees', { replace: true });
            dispatch(getEmployees());
          }, 1500);
        } else {
          CustomAlert({
            action: 'Error',
            msg: error.message || t('SaveError')
          });
        }

        // إعادة توجيه بعد نجاح الحفظ
      } catch (error) {
        console.error('Save error:', error);
        CustomAlert({
          action: 'Error',
          msg: error.message || t('SaveError')
        });
      } finally {
        setSubmitting(false);
      }
    }
  });

  // كشف التغييرات في النموذج
  useEffect(() => {
    if (formik.dirty) {
      setHasUnsavedChanges(true);
    }
  }, [formik.dirty]);

  const handleCancel = useCallback(() => {
    if (hasUnsavedChanges) {
      if (window.confirm(t('UnsavedChangesWarning'))) {
        Navigate(-1, { replace: true });
      }
    } else {
      Navigate(-1, { replace: true });
    }
  }, [hasUnsavedChanges, Navigate, t]);

  if (dataLoading) {
    return (
      <div className='d-flex justify-content-center align-items-center' style={{ height: '400px' }}>
        <div className='text-center'>
          <div className='spinner-border text-theme' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
          <p className='mt-2 text-muted'>{t('LoadingEmployeeData')}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='container mt-4'>
        <Alert variant='danger'>
          <div className='d-flex align-items-center'>
            <i className='fa fa-exclamation-triangle fa-lg me-3'></i>
            <div>
              <h5 className='alert-heading mb-2'>{t('LoadError')}</h5>
              <p className='mb-0'>{error}</p>
              <button className='btn btn-outline-danger mt-3' onClick={() => window.location.reload()}>
                <i className='fa fa-refresh me-2'></i>
                {t('Retry')}
              </button>
            </div>
          </div>
        </Alert>
      </div>
    );
  }

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: ':moduleHome'
          },
          {
            name: 'Employees',
            link: '/HR/Employees'
          },
          {
            name: t('EmployeeDetails'),
            link: null
          }
        ]}
        PageName={t('EmployeeDetails')}
        subtitle={i18n.language === 'ar' ? Employee.name2 : Employee.name}
      />

      <Card className='border-0'>
        <CardBody>
          <Form onSubmit={formik.handleSubmit} onChange={handleFormChange}>
            <EditEmployees formik={formik} />

            {/* قسم المعلومات الإضافية */}

            <Card className='shadow-sm mt-4'>
              <CardHeader className='bg-secondary bg-opacity-50'>
                <div className='d-flex align-items-center'>
                  <i className='fa  fa-info-circle text-theme me-2'></i>
                  <h6 className='mb-0  '>{t('ExtraInformation')}</h6>
                </div>
              </CardHeader>
              <CardBody>
                {Employee?.extraInformationId ? (
                  <ExtraInformationBuilderUpdate
                    extraInformationId={formik.values.ExtraInformationId}
                    referenceId={Employee?.id}
                    setExtraInfoFormData={setExtraInfoFormData}
                  />
                ) : (
                  <ExtraInformationBuilderAdd
                    FormColumnList={FormColumnByTableIdList}
                    setExtraInfoFormData={setExtraInfoFormData}
                    referenceId={Employee?.id}
                  />
                )}
              </CardBody>
            </Card>

            {/* أزرار التنفيذ */}
            <div
              className='sticky-bottom   py-3 border-top'
              style={{
                backdropFilter: 'blur(20px)'
               }}
            >
              <div className='text-center'>
                {HasPermission('EditHrPerson') && (
                  <button
                    // disabled={formik.isSubmitting || !formik.dirty}
                    disabled={formik.isSubmitting}
                    type='submit'
                    className='btn me-1 btn-theme mb-1 btn-lg px-4 rounded-2'
                  >
                    {formik.isSubmitting ? (
                      <>
                        <i className='fa fa-spinner fa-spin fa-fw me-2'></i>
                        {t('Saving')}...
                      </>
                    ) : (
                      <>
                        <i className='fa fa-save fa-fw me-2'></i>
                        {t('SaveChanges')}
                      </>
                    )}
                  </button>
                )}

                <button
                  type='button'
                  className='btn me-1 btn-outline-secondary mb-1 btn-lg px-4 rounded-2'
                  onClick={handleCancel}
                  disabled={formik.isSubmitting}
                >
                  <i className='fa fa-times fa-fw me-2'></i>
                  {t('Cancel')}
                </button>
              </div>
            </div>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};

export default UpdatePerson;
